@use "../../styles/background";

hp6-background {
  display: inline-block;
  width: 100%;
  @include background.background;
}
